export enum FeatureFlagConstant {
  BookingPaymentStep = 'Madar_2_FE_Enable_Payment_Page_onlineBooking',
}
